window.addEventListener('load', () => setupFlickityMobile())
window.addEventListener('resize', () => setupFlickityMobile())

function setupFlickityMobile() {
    var elem = document.querySelector('.mobile-carousel')
    if (!elem) return
    var flkty = new Flickity(elem, {
        // options
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false
    })
    if (window.innerWidth > 768) {
        flkty.destroy()
        elem.classList.add('flickity-desktop')
    } else {
        elem.classList.remove('flickity-desktop')
    }
}
